import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TableHeaderCheckbox } from 'primeng/table';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'avano-tableHeaderCheckbox',
  templateUrl: './avano-table-header-checkbox.component.html',
  styleUrls: ['./avano-table-header-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoTableHeaderCheckboxComponent extends TableHeaderCheckbox {

  multipleEntriesSelected = false;

  updateCheckedState(): boolean {
    this.cd.markForCheck();

    const currentTable = this.dt.value;
    const currentselection = this.dt.selection;
    if (currentTable?.length && currentselection?.length) {
      this.multipleEntriesSelected = currentselection.length < currentTable.length;
    } else {
      this.multipleEntriesSelected = false;
    }
    // Different from PrimeNG Avano wants to have the icon for all selected even if we are on a lazyloaded table
    // only on page 1 and select all on page 1.
    if (this.dt.lazy) {
      return currentTable && currentTable.length > 0 && this.dt.selection && this.dt.selection.length > 0 && this.dt.selection.length === currentTable.length;
    } else {
      // For every other case, just rely on the primeNG-functionality
      return super.updateCheckedState();
    }
  }
}
